import Vue from 'vue'

const PRODUCTION_DOMAIN = 'https://hotmart.com'

function resolveEnvironmentUrl(url) {
  if (!url || typeof url !== 'string') return url

  const baseUrl = process.env.BASE_URL || PRODUCTION_DOMAIN

  if (baseUrl === PRODUCTION_DOMAIN) return url

  if (url.startsWith(`${PRODUCTION_DOMAIN}/`) || url === PRODUCTION_DOMAIN) {
    return url.replace(PRODUCTION_DOMAIN, baseUrl)
  }

  return url
}

function resolveEnvironmentHrefs(data) {
  if (!data || typeof data !== 'object') return data

  if (Array.isArray(data)) {
    return data.map(item => resolveEnvironmentHrefs(item))
  }

  const result = {}

  for (const key in data) {
    const value = data[key]

    if (key === 'href' && typeof value === 'string') {
      result[key] = resolveEnvironmentUrl(value)
    } else if (value && typeof value === 'object') {
      result[key] = resolveEnvironmentHrefs(value)
    } else {
      result[key] = value
    }
  }

  return result
}

/**
 * Plugin centralizado de resolução de URLs por ambiente.
 *
 * - Injeta $resolveEnvironmentUrl e $resolveEnvironmentHrefs no Vue.prototype
 * - Intercepta $t via mixin global beforeCreate
 */
Vue.prototype.$resolveEnvironmentUrl = resolveEnvironmentUrl
Vue.prototype.$resolveEnvironmentHrefs = resolveEnvironmentHrefs

Vue.mixin({
  beforeCreate() {
    const original$t = this.$t

    if (original$t && !this._resolveUrlPatched) {
      this._resolveUrlPatched = true

      this.$t = function (key, ...args) {
        const result = original$t.call(this, key, ...args)

        if (result && typeof result === 'object') {
          return resolveEnvironmentHrefs(result)
        }

        return result
      }
    }
  },
})

export default () => {}
